'use client';

import { signIn } from 'next-auth/react';

interface SignInButtonProps {
  className?: string;
  children?: React.ReactNode;
}

export const SignInButton = ({ className, children }: SignInButtonProps) => {
  const handleSignIn = () => {
    signIn('keycloak', {
      callbackUrl: window.location.href,
      redirect: true
    });
  };

  return (
    <button onClick={handleSignIn} className={className}>
      {children || 'Sign In'}
    </button>
  );
};
